/* FO Baggy fit guide: product page extras.
   - hides the old Kiwi size chart on trou/jeans pages (the guide replaces it)
   - pre-selects the recommended Waist/Length on the product as soon as someone enters their measurements
   - "Add W32 · L32 to basket" adds that size straight to the basket */
(function(){
  var root=document.getElementById('fit-guide');
  if(!root||!root.dataset.product) return;

  function hideKiwi(){
    document.querySelectorAll('#KiwiSizingChart').forEach(function(k){
      var s=k.closest('.shopify-section')||k; s.style.display='none';
    });
  }
  hideKiwi();
  var mo=new MutationObserver(hideKiwi); mo.observe(document.body,{childList:true,subtree:true});
  setTimeout(function(){mo.disconnect()},20000);

  var pick=document.getElementById('pickSize'), flag=document.getElementById('exFlag');
  if(!pick) return;
  var note=document.createElement('p'); note.className='tips'; note.id='pickNote'; note.hidden=true;
  pick.insertAdjacentElement('afterend',note);

  function radios(){return Array.prototype.slice.call(document.querySelectorAll('variant-radios input[type=radio], variant-selects input[type=radio]'))}
  function setOpt(name,val){
    var r=radios().filter(function(x){return x.name===name&&x.value===String(val)})[0];
    if(r){ if(!r.checked){ r.checked=true; r.dispatchEvent(new Event('change',{bubbles:true})) } return true }
    var s=document.querySelector('variant-selects select[name="options['+name+']"]');
    if(s&&Array.prototype.some.call(s.options,function(o){return o.value===String(val)})){
      if(s.value!==String(val)){ s.value=String(val); s.dispatchEvent(new Event('change',{bubbles:true})) } return true }
    return false;
  }
  function choose(w,l){ var a=setOpt('Waist',w), b=setOpt('Length',l); return a&&b }
  function addButton(){ return document.querySelector('product-form [name="add"], form[action*="/cart/add"] [name="add"]') }

  var t=0, lastKey='';
  function sync(){
    var w=pick.dataset.w, l=pick.dataset.l, entered=flag&&flag.hidden;
    if(pick.hidden||!w||!l){ note.hidden=true; return }
    var label='Add W'+w+' · L'+l+' to basket';
    if(pick.textContent!==label) pick.textContent=label;
    // only pre-select once the shopper has typed their own measurements
    if(!entered){ note.hidden=true; return }
    var key=w+'/'+l; if(key===lastKey) return;
    clearTimeout(t);
    t=setTimeout(function(){
      lastKey=key;
      if(choose(w,l)){ note.hidden=false; note.textContent='We’ve selected W'+w+' · L'+l+' on this product for you.' }
    },500);
  }
  new MutationObserver(sync).observe(pick,{attributes:true,attributeFilter:['hidden','data-w','data-l'],childList:true,characterData:true,subtree:true});
  if(flag) new MutationObserver(sync).observe(flag,{attributes:true,attributeFilter:['hidden']});
  sync();

  // take over the button click before the guide's own "select" handler runs
  pick.parentElement.addEventListener('click',function(e){
    if(e.target.closest('#pickSize')!==pick) return;
    e.stopPropagation(); e.preventDefault();
    var w=pick.dataset.w, l=pick.dataset.l;
    if(!choose(w,l)){ var tg=document.querySelector('variant-radios, variant-selects, product-info'); if(tg) tg.scrollIntoView({behavior:'smooth',block:'center'}); return }
    pick.disabled=true; pick.textContent='Adding W'+w+' · L'+l+'…';
    // give the product form a moment to switch to the chosen variant, then add it
    setTimeout(function(){
      var btn=addButton();
      if(btn&&!btn.disabled){ btn.click(); setTimeout(function(){pick.disabled=false; pick.textContent='Added W'+w+' · L'+l},1200) }
      else { pick.disabled=false; pick.textContent='Add W'+w+' · L'+l+' to basket';
        var f=document.querySelector('product-form, product-info'); if(f) f.scrollIntoView({behavior:'smooth',block:'center'}) }
    },450);
  },true);
})();
